import { useRef, useState, useEffect, ReactNode, FC } from "react";

interface AccordionItemProp {
  titleElement: ReactNode;
  contentElement: ReactNode;
  headerClassName?: string;
}

const AccordionItem: FC<AccordionItemProp> = ({
  titleElement,
  contentElement,
  headerClassName,
}) => {
  const parentsRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState(false);
  const [contentHeight, setContentHeight] = useState(0);

  useEffect(() => {
    if (!contentRef.current) return;
    setContentHeight(contentRef.current.scrollHeight);
  }, [contentElement, isOpen]);

  const toggleOpen = () => setIsOpen(!isOpen);

  return (
    <div ref={parentsRef} className="w-full">
      <div
        className={`flex justify-between items-center p-2 border-b border-b-[#f3f3f3] cursor-pointer ${
          headerClassName || ""
        }`}
        onClick={toggleOpen}
      >
        {titleElement}
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            toggleOpen();
          }}
          className={`w-10 h-10 bg-[#f3f3f3] p-2 rounded-full text-primary font-bold ${
            isOpen ? "-rotate-45" : "rotate-0"
          } transition-transform ease-linear duration-200`}
        >
          +
        </button>
      </div>
      <div
        className="transition-[height] ease-linear duration-200"
        style={{ height: isOpen ? contentHeight : 0 }}
      >
        <div
          ref={contentRef}
          className={`transition-opacity ease-linear duration-300 ${
            isOpen
              ? "opacity-100 pointer-events-auto"
              : "opacity-0 pointer-events-none"
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          {contentElement}
        </div>
      </div>
    </div>
  );
};

export default AccordionItem;
